import {
  CLEAR_FETCH_ORG_COLLECTIONS_EM_STATES,
  FETCH_ORG_COLLECTIONS_EM_FAILURE,
  FETCH_ORG_COLLECTIONS_EM_SUCCESS,
  REQUEST_FETCH_ORG_COLLECTIONS_EM,
} from "./orgCollections.types";

let initialState = {
  reload: false,
  response: {},
  error: null,
  loading: false,
};

const orgCollectionsEmReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_FETCH_ORG_COLLECTIONS_EM:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ORG_COLLECTIONS_EM_SUCCESS:
      return {
        ...state,
        loading: false,
        response: action.payload,
        reload: false,
      };

    case FETCH_ORG_COLLECTIONS_EM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        reload: false,
      };

    case CLEAR_FETCH_ORG_COLLECTIONS_EM_STATES:
      return {
        ...state,
        loading: false,
        response: {},
        error: null,
        reload: false,
      };

    default:
      return state;
  }
};

export default orgCollectionsEmReducer;
